<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (navbar.userAccess?.Appointments=='Full' || navbar.userAccess?.Appointments=='Readonly') {
<div class="row g-1">
	<div class="col-12">
		<div class="card">
			<div class="card-header bg-theme mb-0">
				<h5 class="card-title text-light mb-0">
					{{pagetitle}}
				</h5>
			</div>
			<div class="card-body pt-0">
				<div class="table-responsive">
					@if(dtOptions.pagingType){
					<table datatable [dtOptions]="dtOptions"
						class="table table-striped table-bordered table-hover appt-table"
						style="width: 100%;border: 1px solid rgb(187, 187, 187);">
						<thead>
							<tr class="table_head">
								<th>Name</th>
								<th>Phone No.</th>
								<th>Email Id</th>
								<th>IMO No.</th>
								<th>Passport No.</th>
								<th>Crew Id</th>
							</tr>
						</thead>
						@if (dataList?.length) {
						<tbody>
							<tr *ngFor="let v of dataList;let i = index;">
								<td>
									{{ v.name }}
								</td>
								<td>
									{{ v.tel_no }}
								</td>
								<td>
									{{ v.email }}
								</td>
								<td>
									{{ v.imo_no }}
								</td>
								<td>
									{{ v.passport_no }}
								</td>
								<td>
									{{ v.crew_id }}
								</td>
							</tr>
						</tbody>
						}@else {
						<tbody>
							<tr>
								<td colspan="6" class="text-center">No data found!</td>
							</tr>
						</tbody>
						}
					</table>
					}
				</div>
			</div>
		</div>
	</div>
</div>
}@else if(navbar.userAccess?.Appointments=='NoAccess') {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}